import catDaynight from "@/assets/cat-daynight.jpg";
import catShowerCurtain from "@/assets/cat-shower-curtain.jpg";
import catMini from "@/assets/cat-mini.jpg";
import catRoller from "@/assets/cat-roller.jpg";
import catPlisse from "@/assets/cat-plisse.jpg";
import catSilhouette from "@/assets/cat-silhouette.jpg";
import catVertical from "@/assets/cat-vertical.jpg";
import catDouble from "@/assets/cat-double.jpg";
import catHorizontal from "@/assets/cat-horizontal.jpg";
import catBamboo from "@/assets/cat-bamboo.jpg";
import catTulle from "@/assets/cat-tulle.jpg";
import catNetHinged from "@/assets/cat-net-hinged.jpg";
import catNetVentura from "@/assets/cat-mosquito.jpg";
import catNetPlisse from "@/assets/cat-net-plisse.jpg";
import catProjectorScreen from "@/assets/cat-projector-screen.jpg";
import catRolstavni from "@/assets/cat-rolstavni.jpg";

// Per-product gallery shots (color variant + interior)
import pDaynightColor from "@/assets/p-daynight-color.jpg";
import pDaynightInterior from "@/assets/p-daynight-interior.jpg";
import pMiniColor from "@/assets/p-mini-color.jpg";
import pMiniInterior from "@/assets/p-mini-interior.jpg";
import pRollerColor from "@/assets/p-roller-color.jpg";
import pRollerInterior from "@/assets/p-roller-interior.jpg";
import pPlisseColor from "@/assets/p-plisse-color.jpg";
import pPlisseInterior from "@/assets/p-plisse-interior.jpg";
import pSilhouetteColor from "@/assets/p-silhouette-color.jpg";
import pSilhouetteInterior from "@/assets/p-silhouette-interior.jpg";
import pVerticalColor from "@/assets/p-vertical-color.jpg";
import pVerticalInterior from "@/assets/p-vertical-interior.jpg";
import pDoubleColor from "@/assets/p-double-color.jpg";
import pDoubleInterior from "@/assets/p-double-interior.jpg";
import pHorizontalColor from "@/assets/p-horizontal-color.jpg";
import pHorizontalInterior from "@/assets/p-horizontal-interior.jpg";
import pBambooColor from "@/assets/p-bamboo-color.jpg";
import pBambooInterior from "@/assets/p-bamboo-interior.jpg";
import pTulleColor from "@/assets/p-tulle-color.jpg";
import pTulleInterior from "@/assets/p-tulle-interior.jpg";
import pProjectorColor from "@/assets/p-projector-color.jpg";
import pProjectorInterior from "@/assets/p-projector-interior.jpg";
import pNetHingedColor from "@/assets/p-net-hinged-color.jpg";
import pNetHingedInterior from "@/assets/p-net-hinged-interior.jpg";
import pNetVenturaColor from "@/assets/p-net-ventura-color.jpg";
import pNetVenturaInterior from "@/assets/p-net-ventura-interior.jpg";
import pNetPlisseColor from "@/assets/p-net-plisse-color.jpg";
import pNetPlisseInterior from "@/assets/p-net-plisse-interior.jpg";
import pShowerColor from "@/assets/p-shower-color.jpg";
import pShowerInterior from "@/assets/p-shower-interior.jpg";

export interface ProductGalleryShot {
  src: string;
  /** CSS object-position used to make a single source image yield distinct,
   *  visually different slides (wide view / close-up / detail). */
  position?: string;
  /** CSS scale to simulate close-up framing. */
  zoom?: number;
  label?: string;
}

export interface ProductCategory {
  id: string;
  title: string;
  description: string;
  image: string;
  category: string;
  benefits: string[];
  priceHint?: string;
  priceFrom?: number;
  /** Optional badge label (e.g. "Новинка"). When omitted ProductGrid falls back to "Хит" for top products. */
  badge?: string;
  /** Optional small caption shown under the price (used when priceHint is non-numeric like "Индивидуальный расчёт"). */
  priceNote?: string;
  /** Optional dedicated landing slug used for "Подробнее" links from the catalog card. */
  landingSlug?: string;
  /** Optional explicit gallery; if omitted, modal generates 3 distinct
   *  framings from the main image. */
  gallery?: ProductGalleryShot[];
  /** Optional explicit alt text for the product card image. */
  alt?: string;
}

/** Global PDF links — edit these when you have real URLs */
export const pdfLinks = {
  catalog: "",
  price: "",
};

/** Telegram direct chat link — set your manager's username */
export const telegramManagerLink = "https://t.me/JaluziShop_bot";

const buildGallery = (main: string, color: string, interior: string): ProductGalleryShot[] => [
  { src: main, label: "Текстура материала" },
  { src: color, label: "Вариант цвета" },
  { src: interior, label: "В интерьере" },
];

export const categories: ProductCategory[] = [
  // ─── Жалюзи ───
  {
    id: "daynight",
    title: "Жалюзи День-Ночь (Combo)",
    description: "Современное решение для управления светом. Чередование прозрачных и плотных полос позволяет легко регулировать освещение и приватность.",
    image: catDaynight,
    category: "Жалюзи",
    priceHint: "от 175 000 сум/м²",
    priceFrom: 175000,
    benefits: [
      "Плавная регулировка от полного света до полной темноты",
      "Более 120 расцветок и текстур в наличии",
      "Гарантия на механизм — 1 год",
    ],
    gallery: buildGallery(catDaynight, pDaynightColor, pDaynightInterior),
  },
  {
    id: "mini",
    title: "Мини жалюзи (День-Ночь на каждую створку)",
    description: "Компактное решение для каждого окна отдельно. Устанавливаются на каждую створку и не занимают лишнего пространства.",
    image: catMini,
    category: "Жалюзи",
    priceHint: "52 000 сум за изделие",
    priceFrom: 52000,
    benefits: [
      "Крепятся на каждую створку отдельно",
      "Компактный и аккуратный внешний вид",
      "Идеальны для кухни, балкона и детской",
    ],
    gallery: buildGallery(catMini, pMiniColor, pMiniInterior),
  },
  {
    id: "roller",
    title: "Рулонные шторы (Ролло)",
    description: "Минималистичное решение для современного интерьера. Полностью закрывают окно и защищают от солнца.",
    image: catRoller,
    category: "Жалюзи",
    priceHint: "от 250 000 сум/м²",
    priceFrom: 250000,
    benefits: [
      "Компактный короб — экономия пространства",
      "Ткани блэкаут, димаут и полупрозрачные",
      "Защита от солнца до 98%",
      "Подходят для пластиковых и деревянных окон",
    ],
    gallery: buildGallery(catRoller, pRollerColor, pRollerInterior),
  },
  {
    id: "plisse",
    title: "Жалюзи Плиссе",
    description: "Лёгкость и эстетика. Отлично подходят для нестандартных окон и дизайнерских решений.",
    image: catPlisse,
    category: "Жалюзи",
    priceHint: "от 99 000 сум (до 0,5 м²)",
    priceFrom: 99000,
    benefits: [
      "Единственный вариант для треугольных и арочных окон",
      "Ткань со специальной пропиткой от пыли",
      "Управление сверху и снизу одновременно",
      "Премиальный внешний вид для дорогих интерьеров",
    ],
    gallery: buildGallery(catPlisse, pPlisseColor, pPlisseInterior),
  },
  {
    id: "silhouette",
    title: "Жалюзи Силуэт",
    description: "Премиальное решение с мягким рассеиванием света. Создают эффект лёгкой тюли.",
    image: catSilhouette,
    category: "Жалюзи",
    priceHint: "185 000 сум/м²",
    priceFrom: 185000,
    benefits: [
      "Мягкое рассеивание света без бликов",
      "Элегантный внешний вид — эффект тюли",
      "Защита мебели от выгорания",
      "Простое управление цепочным механизмом",
    ],
    gallery: buildGallery(catSilhouette, pSilhouetteColor, pSilhouetteInterior),
  },
  {
    id: "vertical",
    title: "Вертикальные тканевые",
    description: "Классический вариант для больших окон и офисов. Практично и удобно в использовании.",
    image: catVertical,
    category: "Жалюзи",
    priceHint: "от 185 000 сум/м²",
    priceFrom: 185000,
    benefits: [
      "Идеальны для больших панорамных окон",
      "Более 80 тканей на выбор",
      "Удобный цепочный или электропривод",
      "Просты в обслуживании — ламели заменяемы",
    ],
    gallery: buildGallery(catVertical, pVerticalColor, pVerticalInterior),
  },
  {
    id: "double",
    title: "Жалюзи Double",
    description: "Двухслойная система в одном окне: сзади рулонная штора (ролло), спереди жалюзи День-Ночь (Combo). Больше контроля света, приватности и защиты от солнца.",
    image: catDouble,
    category: "Жалюзи",
    priceHint: "от 370 000 сум/м²",
    priceFrom: 370000,
    benefits: [
      "Двойной слой для полного контроля света",
      "Максимальная приватность в любое время суток",
      "Премиальный внешний вид",
      "Подходит для спальни и гостиной",
    ],
    gallery: buildGallery(catDouble, pDoubleColor, pDoubleInterior),
  },
  {
    id: "horizontal",
    title: "Горизонтальные алюминиевые",
    description: "Надёжные и практичные жалюзи. Идеально подходят для кухни и офиса.",
    image: catHorizontal,
    category: "Жалюзи",
    priceHint: "от 185 000 сум (до 0,5 м²)",
    priceFrom: 185000,
    benefits: [
      "Устойчивы к влаге, жаре и перепадам температуры",
      "Легко моются влажной тряпкой",
      "Точная регулировка угла наклона ламелей",
      "Алюминий с покрытием — не выгорает на солнце",
    ],
    gallery: buildGallery(catHorizontal, pHorizontalColor, pHorizontalInterior),
  },
  {
    id: "bamboo",
    title: "Бамбуковые жалюзи",
    description: "Натуральный стиль и уют. Экологичное решение для современного интерьера.",
    image: catBamboo,
    category: "Жалюзи",
    priceHint: "270 000 сум/м²",
    priceFrom: 270000,
    benefits: [
      "100% натуральный экологичный материал",
      "Тёплые природные оттенки — 18 вариантов",
      "Создают уют в спальне, гостиной и на веранде",
      "Срок службы более 10 лет",
    ],
    gallery: buildGallery(catBamboo, pBambooColor, pBambooInterior),
  },
  {
    id: "tulle",
    title: "Тюль DK",
    description: "Современная альтернатива шторам. Мягко рассеивает свет и создаёт уют.",
    image: catTulle,
    category: "Жалюзи",
    priceHint: "от 369 000 сум/м²",
    priceFrom: 369000,
    benefits: [
      "Мягкое и равномерное рассеивание света",
      "Современная альтернатива классическим шторам",
      "Легко стирается и не мнётся",
      "Элегантный минималистичный дизайн",
    ],
    gallery: buildGallery(catTulle, pTulleColor, pTulleInterior),
  },
  {
    id: "projector-screen",
    title: "Ролло-экран для проектора",
    description: "Идеальное решение для просмотра фильмов и презентаций дома или в офисе. Ролло-экран обеспечивает чёткое изображение, удобен в использовании и легко вписывается в современный интерьер.",
    image: catProjectorScreen,
    category: "Жалюзи",
    priceHint: "Цена по запросу",
    benefits: [
      "Чёткое и яркое изображение для фильмов и презентаций",
      "Удобное управление — плавное опускание и подъём",
      "Аккуратно вписывается в современный интерьер",
      "Подходит для дома и офиса",
    ],
    gallery: buildGallery(catProjectorScreen, pProjectorColor, pProjectorInterior),
  },
  // ─── Москитные сетки ───
  {
    id: "net-hinged",
    title: "Сетки на уголках / на петлях",
    description: "Простое и доступное решение для защиты от насекомых.",
    image: catNetHinged,
    category: "Москитные сетки",
    priceHint: "от 185 000 сум/м²",
    priceFrom: 185000,
    benefits: [
      "Простой и надёжный монтаж",
      "Доступная цена",
      "Подходит для любых окон",
      "Легко снимается для мытья",
    ],
    gallery: buildGallery(catNetHinged, pNetHingedColor, pNetHingedInterior),
  },
  {
    id: "net-ventura",
    title: "Сетки Вентура",
    description: "Усиленная конструкция с удобным открыванием. Подходит для частого использования.",
    image: catNetVentura,
    category: "Москитные сетки",
    priceHint: "250 000 сум/м²",
    priceFrom: 250000,
    alt: "Внутренняя противомоскитная сетка без сверления на окно в Ташкенте",
    benefits: [
      "Усиленная алюминиевая рама",
      "Удобное открывание на петлях",
      "Подходит для частого использования",
      "Долговечная конструкция",
    ],
    gallery: buildGallery(catNetVentura, pNetVenturaColor, pNetVenturaInterior),
  },
  {
    id: "net-plisse",
    title: "Сетки Плиссе",
    description: "Премиальная раздвижная система для дверей и больших проёмов.",
    image: catNetPlisse,
    category: "Москитные сетки",
    priceHint: "430 000 сум/м²",
    priceFrom: 430000,
    benefits: [
      "Раздвижная система — удобно для дверей",
      "Премиальный внешний вид",
      "Подходит для больших проёмов до 3 м",
      "Плавный ход без заеданий",
    ],
    gallery: buildGallery(catNetPlisse, pNetPlisseColor, pNetPlisseInterior),
  },

  // ── Шторы для ванной ──
  {
    id: "shower-curtain-miranda",
    title: "Шторки для ванной Miranda",
    description: "Практичное и стильное решение для ванной комнаты. Турецкое качество Miranda обеспечивает защиту от воды и аккуратный внешний вид.",
    image: catShowerCurtain,
    category: "Шторы для ванной",
    priceHint: "156 000 сум",
    priceFrom: 156000,
    benefits: [
      "Турецкое качество Miranda",
      "Надёжная защита от воды",
      "Стильный внешний вид",
      "Легко устанавливается и снимается",
    ],
    gallery: buildGallery(catShowerCurtain, pShowerColor, pShowerInterior),
  },

  // ─── Защитные системы ───
  {
    id: "rolstavni",
    title: "Рольставни",
    description:
      "Защитные роллетные системы для окон, дверей, витрин и гаражей. Помогают защитить помещение от солнца, пыли, ветра и постороннего доступа.",
    image: catRolstavni,
    category: "Защитные системы",
    badge: "Новинка",
    priceHint: "Индивидуальный расчёт",
    priceNote: "Точная стоимость зависит от размера, типа профиля и управления.",
    landingSlug: "rolstavni-tashkent",
    benefits: [
      "Для окон, дверей, витрин и гаражей",
      "Ручное и автоматическое управление",
      "Изготовление под размер проёма",
      "Бесплатный замер по Ташкенту",
      "Аккуратный монтаж под ключ",
    ],
  },
];
